import { Tabs, type TabsItem } from "@cynthai/ui";
import {
  createFileRoute,
  Outlet,
  useLocation,
  useRouter,
} from "@tanstack/react-router";

import PageContainer from "@/core/ui/layout/PageContainer";

export const Route = createFileRoute("/_protected/superuser/user/$id")({
  component: SuperuserUserLayout,
});

function SuperuserUserLayout() {
  const router = useRouter();
  const { id } = Route.useParams();
  const pathname = useLocation({ select: (l) => l.pathname });

  const tabs: TabsItem<string>[] = [
    {
      label: "Roles",
      value: `/superuser/user/${id}/roles`,
    },
    {
      label: "Permissions",
      value: `/superuser/user/${id}/permissions`,
    },
  ];

  return (
    <PageContainer withPageHeader={false} className="overflow-y-hidden">
      <div
        className={`bg-background-2 flex min-h-0 flex-1 flex-col gap-0 rounded-lg`}
      >
        <div className="flex min-h-0 flex-1 flex-col">
          <Tabs
            classNames={{
              panel: "flex-1 min-h-0 flex flex-col !p-0",
              list: "overflow-x-auto",
              listWrapper: "bg-secondary/50 !p-1.5 my-6 ",
              item: "flex-auto !h-8",
            }}
            variant="default"
            className="flex min-h-0 flex-1 flex-col px-6"
            selectedKey={pathname}
            items={tabs}
            onSelectionChange={(value) => {
              if (!value) return;
              router.navigate({ to: value });
            }}
          >
            <Outlet />
          </Tabs>
        </div>
      </div>
    </PageContainer>
  );
}
